export enum CommentState {
	Created = 0,
	Updated,
	Deleted,
}
